import { render } from "./AddQuestionPopup.vue?vue&type=template&id=285121c6&scoped=true"
import script from "./AddQuestionPopup.vue?vue&type=script&lang=js"
export * from "./AddQuestionPopup.vue?vue&type=script&lang=js"

import "./AddQuestionPopup.vue?vue&type=style&index=0&id=285121c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285121c6"]])

export default __exports__